// import 'babel-polyfill';
import "@elsa-zku/lib/helpers/catchChunkLoadError";
import 'destyle.css';
import "@elsa-zku/lib/styles/_fontFaceMontserrat.scss";
import "@elsa-zku/lib/styles/_typography.scss";
import './style/common.scss';

import { setApiUrl } from "src/api/http-client";
import * as ws from '@elsa-zku/lib/helpers/websockets';

setApiUrl(process.env.API_URL + '/api/');
ws.setProject('heat');
ws.init();

import * as React from 'react';
import { createRoot } from 'react-dom/client';
import App from "@elsa-zku/lib/components/App";
import UserAuthGuard from "src/components/UserAuthGuard";

import routes from "src/routes";
import menu, { SidebarContext } from "src/menu";
import { initBuildings, useSelectedBuildingId, useSelectedBuildingOnlyForReports } from "src/store/buildings";
import { auth } from "src/store/user";
import InstructionLink from "src/components/InstructionLink";

auth();
initBuildings();

const app = (
  <App
    routes={routes}
    menu={menu}
    defaultRouteUrl="/buildings"
    baseUrl={process.env.BASE_URL}
    getSidebarContext={(): SidebarContext => ({
      selectedBuildingId: useSelectedBuildingId(),
      onlyForReports:     useSelectedBuildingOnlyForReports(),
    })}
    renderSidebarFooter={() => <InstructionLink />}
    renderRouter={(renderer) => <UserAuthGuard>{renderer}</UserAuthGuard>}
    additionalRoutes={[
      {
        path: '/login',
        lazy: () => import('src/routes/Login').then(({ default: Component }: any) => ({ Component })),
      },
    ]}
  />
);

const root = createRoot(document.getElementById('app'));
root.render(app);

